import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import './components/shared/layout.css';
import './App.css';
import ViewGoalcardPage from 'pages/ViewGoalcard/index';
import GoalcardAnimatedPage from 'pages/ViewGoalcard/GoalcardAnimatedPage';
import UserProfilePage from 'pages/UserProfile/index';
import { isIE } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import PublicGoalPage from './pages/PublicGoal/index';
import Header from './components/shared/Header/Header';
import Footer from './components/shared/Footer/Footer';
import ForgotPasswordPage from './pages/ForgotPassword/ForgotPasswordPage';
import RecoverPasswordPage from './pages/RecoverPassword/RecoverPasswordPage';
import RecoverPasswordSuccessPage from './pages/RecoverPasswordSuccess/RecoverPasswordSuccessPage';
import SelectCard from './pages/SelectCard';
import GiftPage from './pages/Gift/index';
import CustomizePage from './pages/Customize';
import PurchaseGoalcardWrapperPage from './pages/Purchase/WrapperPage';
import SuccessPage from './pages/Success';
import NotFound from './pages/NotFound';
import SsoSignup from './pages/SsoSignup';
import { usePageTracking } from './utils/analyticsWrapper';
import ErrorPopUp from './components/shared/ErrorPopUp/ErrorPopUp';

const getValidRoutes = () => [
  '/anim/viewgcanimated.aspx',
  '/viewgoalcard',
  '/goalcard',
  '/selectgoalcard',
  '/forgotpassword',
  '/resetpassword',
  '/successpassword',
  '/gift',
  '/customize',
  '/purchase',
  '/success',
];

const getValidRoutesREST = () => [
  /\/user\/([^/]+)\/([^/]+)$/g, // Reg exp match with goal profile page
  /\/user\/([^/]+)\/([^/]+)\/share$/g, // Reg exp match with share goal page
  /\/user\/([^/]+)$/g, // Reg exp match with user profile URL,
  /\/user\/([^/]+)\/share$/g, // Reg exp match with user profile URL SHARE
  /\/goalcard\/([^/]+)$/g, // Reg exp match with goalcard affilaite code,
];

const isValidRoute = (route) => {
  let exists = getValidRoutes().find((r) => r.includes(route)) !== undefined;

  if (!exists) {
    exists = getValidRoutesREST().find((r) => r.test(route)) !== undefined;
  }

  return exists;
};

const NotFoundRoute = () => {
  if (isValidRoute(useLocation().pathname) === false) {
    return <Route component={NotFound} />;
  }

  return null;
};

const CompatibleBrowserChecker = () => {
  const { t } = useTranslation();
  if (isIE) {
    return (
      <ErrorPopUp
        show
        title={t('browser_not_supported_title')}
        description={t('browser_not_supported_description')}
      />
    );
  }

  return null;
};

const App = () => {
  usePageTracking();

  const location = useLocation();

  if (location.pathname === '/') {
    return <Redirect to="/gift" />;
  }

  AddMetaTagRobotsForSandboxEnvironments();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Header />
      <div style={{ flexGrow: 1 }}>
        <AnimatedRoute path="/anim/viewgcanimated.aspx" component={ViewGoalcardPage} />
        <AnimatedRoute path="/viewgoalcard" component={ViewGoalcardPage} />
        <AnimatedRoute path="/goalcard/:code" component={GoalcardAnimatedPage} />
        <AnimatedRoute path="/goalcard" component={GoalcardAnimatedPage} />
        <AnimatedRoute path="/selectgoalcard" component={SelectCard} />
        <AnimatedRoute path="/forgotpassword" component={ForgotPasswordPage} />
        <AnimatedRoute path="/resetpassword" component={RecoverPasswordPage} />
        <AnimatedRoute path="/successpassword" component={RecoverPasswordSuccessPage} />
        <AnimatedRoute path="/gift" component={GiftPage} />
        <AnimatedRoute path="/customize" component={CustomizePage} />
        <AnimatedRoute path="/purchase" component={PurchaseGoalcardWrapperPage} />
        <AnimatedRoute path="/success" component={SuccessPage} />
        <AnimatedRoute path="/user/:userName/:goalName/share" component={PublicGoalPage} />
        <AnimatedRoute path="/user/:userName/share" component={UserProfilePage} />
        <AnimatedRoute path="/user/:userName/:goalName" component={PublicGoalPage} />
        <AnimatedRoute path="/user/:userName" component={UserProfilePage} />
        <AnimatedRoute path="/sso_signup" component={SsoSignup} />
        <NotFoundRoute />

        <CompatibleBrowserChecker />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

const AddMetaTagRobotsForSandboxEnvironments = () => {
  const env = process.env.REACT_APP_ENV;
  if(env != "PROD"){
    var tagRobot = document.getElementsByName('robots');

    if(tagRobot.length == 0){
      var meta = document.createElement('meta');
      meta.name = "robots";
      meta.content = "noindex";
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }
}

const AnimatedRoute = ({ path, component: Component }) => (
  <Route exact path={path}>
    {({ match }) => (
      <CSSTransition
        in={match != null}
        timeout={30}
        classNames="page"
        unmountOnExit
      >
        <>
          <Component />
        </>
      </CSSTransition>
    )}
  </Route>
);

const NoHeaderLayout = ({ path, component: Component }) => (
  <Route exact path={path}>
    {({ match }) => (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div style={{ flexGrow: 1 }}>
          <Component />
        </div>
        <div>
          <Footer />
        </div>
      </div>
    )}
  </Route>
);

export default App;
